// extracted by mini-css-extract-plugin
export default {"container":"InitialLoadingScreen_container__9Ub3m","loaderWrapper":"InitialLoadingScreen_loaderWrapper__bG56C","text":"InitialLoadingScreen_text__1gIZH"};